





































































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import AddDialog from '@/views/trainManagement/trainRequest/addDialog.vue';
import { trainServer } from '@/api/installServer';

@Component({
  components: { PagingUnit, CollapseTransition, AddDialog },
  mixins: [TableStripe],
})
export default class LicenseManagement extends Vue {
  private tableLoading = false; // loading...
  private tableData: any = [{}];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
    trainName: '', //搜索培训
    trainUnitName: '', //单位
  };
  private total = 0;

  created() {
    this.getTableData();
  }

  private onSearch() {
    (this.queryDataForm as any).pageNo = 1;
    this.getTableData();
  }

  private onReset() {
    (this.$refs.form as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    trainServer
      .trainRequestTable({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        trainName: this.queryDataForm.trainName ? this.queryDataForm.trainName : null,
        trainUnitName: this.queryDataForm.trainUnitName ? this.queryDataForm.trainUnitName : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          trainServer.trainRequestDelete(data).then((res: any) => {
            if (res.code == 200) {
              this.$message.success('删除成功');
              this.getTableData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.AddDialog as any).showDialog(passValue);
    }
  }
}
